/* eslint-disable */
import axios from "axios";
import store from "@/store";
import customModal from "../customModal/customModal.vue";

export default {
    name: "manageQtlModal",

    components: {
        customModal,
    },

    props: {
        qtlEditData: {
            type: Object,
            default: null,
        },
    },

    emits: ["closeModal", "reloadList"],

    computed: {
        isEditMode() {
            return !!this.form.id;
        },
    },

    data() {
        return {
            baseurl: process.env.VUE_APP_Service_URL,
            studyId: "",
            token: "",
            submitting: false,
            errors: {
                qtlId: "",
                qualityMetric: "",
                qtlCalculationlogic: "",
            },
            form: {
                id: "",
                studyId: "",
                qtlId: "",
                ctqId: "",
                ctqFactor: "",
                ctqCategory: "",
                qtlDescription: "",
                thresholdType: "",
                qtlAcceptableLimits: "",
                qtlCalculationlogic: "",
                monitoringFrequency: "",
                escalationAction: "",
                responsibleOwner: "",
                reviewPeriod: "",
                status: "",
                qualityMetric: "",
                thresholds: [],
            },
        };
    },

    mounted() {
        this.studyId = store.getters.getStudyIs;
        this.token = store.getters.getIdToken;

        if (this.qtlEditData) {
            this.form.id = this.qtlEditData.id || "";
            this.form.qtlId = this.qtlEditData.qtlId || "";
            this.form.ctqId = this.qtlEditData.ctqId || "";
            this.form.ctqFactor = this.qtlEditData.ctqFactor || "";
            this.form.ctqCategory = this.qtlEditData.ctqCategory || "";
            this.form.qtlDescription = this.qtlEditData.qtlDescription || "";
            this.form.thresholdType = this.qtlEditData.thresholdType || "";
            this.form.qtlAcceptableLimits = this.qtlEditData.qtlAcceptableLimits || "";
            this.form.qtlCalculationlogic = this.qtlEditData.qtlCalculationlogic || "";
            this.form.monitoringFrequency = this.qtlEditData.monitoringFrequency || "";
            this.form.escalationAction = this.qtlEditData.escalationAction || "";
            this.form.responsibleOwner = this.qtlEditData.responsibleOwner || "";
            this.form.reviewPeriod = this.qtlEditData.reviewPeriod || "";
            this.form.status = this.qtlEditData.isActive === false ? "Inactive" : "Active";
            this.form.qualityMetric = this.qtlEditData.qualityMetric || "";
            this.form.thresholds = Array.isArray(this.qtlEditData.thresholds)
                ? this.qtlEditData.thresholds.map((t) => ({ ...t }))
                : [];
        }
    },

    methods: {
        closeModal() {
            this.$emit("closeModal");
        },

        clear() {
            this.errors.qtlId = "";
            this.errors.qualityMetric = "";
            this.errors.qtlCalculationlogic = "";

            this.form.qtlId = "";
            this.form.qualityMetric = "";
            this.form.ctqCategory = "";
            this.form.qtlDescription = "";
            this.form.thresholdType = "";
            this.form.qtlAcceptableLimits = "";
            this.form.qtlCalculationlogic = "";
            this.form.monitoringFrequency = "";
            this.form.escalationAction = "";
            this.form.responsibleOwner = "";
            this.form.reviewPeriod = "";
            this.form.status = "";
            this.form.thresholds = [];
        },

        addThreshold() {
            this.form.thresholds.push({
                min: 0,
                max: 0,
                label: "",
                color: "",
            });
        },

        removeThreshold(index) {
            this.form.thresholds.splice(index, 1);
        },

        validate() {
            this.errors.qtlId = "";
            this.errors.qualityMetric = "";
            this.errors.qtlCalculationlogic = "";
            let isValid = true;

            if (!this.form.qtlId || !this.form.qtlId.trim()) {
                this.errors.qtlId = "QTL ID is required.";
                isValid = false;
            }
            if (!this.form.qualityMetric || !this.form.qualityMetric.trim()) {
                this.errors.qualityMetric = "Quality Metric is required.";
                isValid = false;
            }
            if (!this.form.qtlCalculationlogic || !this.form.qtlCalculationlogic.trim()) {
                this.errors.qtlCalculationlogic = "QTL Calculation Logic is required.";
                isValid = false;
            }
            return isValid;
        },

        async saveClicked() {
            if (!this.validate()) return;
            this.submitting = true;

            const payload = {
                studyId: this.studyId,
                qtlId: this.form.qtlId,
                ctqId: this.form.ctqId,
                ctqFactor: this.form.ctqFactor,
                thresholdType: this.form.thresholdType,
                monitoringFrequency: this.form.monitoringFrequency,
                escalationAction: this.form.escalationAction,
                responsibleOwner: this.form.responsibleOwner,
                reviewPeriod: this.form.reviewPeriod,
                qualityMetric: this.form.qualityMetric,
                thresholds: this.form.thresholds.map((t) => ({
                    min: Number(t.min) || 0,
                    max: Number(t.max) || 0,
                    label: t.label || "",
                    color: t.color || "",
                })),
                isActive: this.form.status !== "Inactive",
                ctqCategory: this.form.ctqCategory,
                qtlDescription: this.form.qtlDescription,
                qtlCalculationlogic: this.form.qtlCalculationlogic,
                qtlAcceptableLimits: this.form.qtlAcceptableLimits,
            };

            try {
                const config = {
                    headers: {
                        Authorization: "Bearer " + this.token,
                        "Content-Type": "application/json",
                    },
                };

                if (this.isEditMode) {
                    // Update URL endpoint: /forms/qtl/update?id=1
                    await axios.put(`${this.baseurl}/forms/qtl/update?id=${this.form.id}`, payload, config);
                    alert("Quality Tolerance Limit updated successfully");
                } else {
                    // Create URL endpoint: /forms/qtl/create
                    await axios.post(`${this.baseurl}/forms/qtl/create`, payload, config);
                    alert("Quality Tolerance Limit created successfully");
                }

                this.$emit("reloadList");
                this.closeModal();
            } catch (error) {
                console.error("Error saving QTL:", error);
                alert("Failed to save Quality Tolerance Limit. Please check details and try again.");
            } finally {
                this.submitting = false;
            }
        },
    },
};